import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../components/router/router-tabbed-navigation';
import { UserauthAccessRequestsTable } from '../../../../../features/userauth/access-request/userauth-access-requests-table';
import { PlatformUsersTabRail } from '../../../../../features/userauth/platform-users-tab-rail';
import { getPageHead } from '../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_platform/_context-required/user/request')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.PlatformUsers,
      label: 'Requests',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.PlatformUsers>,
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'user-request-list',
        label: 'Users',
        to: '/user/request',
      }),
    }) satisfies AggregateBreadcrumb,
  head: () => getPageHead('Requests'),
  component: AccessRequestList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PlatformUsersTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
    />
  );
}

function AccessRequestList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <UserauthAccessRequestsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
